import MultiStepForm from '@/components/forms/MultiStepForm';
import GeneralUserSubscriptions from '@/components/forms/apps/GeneralUserSubscriptions';
import WeclappInterfaceForm from '@/components/forms/apps/WeclappInterfaceForm';
import TanssInterfaceForm from '@/components/forms/apps/TanssInterfaceForm';
import PrinterForm from '@/components/forms/apps/warehouse/PrinterForm';
import tenant from '@/services/TenantService';
import { toast } from 'react-toastify';
import ToastMessage from '@/components/toasts/ToastMessage';

export default function WareHouseSetup({
  app,
  onFinish,
  onCancel,
  deployment,
}) {
  const depl = deployment || {};
  const steps = [
    <WeclappInterfaceForm key="weclappInterface" app={app} />,
    <TanssInterfaceForm key="tanssInterface" app={app} />,
    <PrinterForm key="printer" app={app} />,
    <GeneralUserSubscriptions key="userSubcriptions" app={app} />,
  ];

  // TODO: Delete the deployment if the user cancels the setup process.
  // TODO: Delete the printer role if the user cancels the setup process.
  const handleSubmit = async (formData, users) => {
    const deploymentData = {
      app: app._id,
      config: formData,
    };
    try {
      const deploymentResponse = await tenant.put(
        `/deployment/${depl.insertedId}`,
        deploymentData,
      );
      const { deployment } = deploymentResponse.data;
      await tenant.post('/subscription', {
        userIds: users,
        deploymentId: depl.insertedId,
      });
      onFinish(deployment, users);
    } catch (error) {
      try {
        await tenant.delete(`role/${formData?.printer?.role}`);
      } catch (error) {
        toast.error(
          <ToastMessage
            title="Fehler"
            subtitle={
              error?.response?.data?.message ||
              'Fehler beim Erstellen der Konfiguration'
            }
          />,
        );
      }
      toast.error(
        <ToastMessage
          title="Fehler"
          subtitle={
            error?.response?.data?.message ||
            'Fehler beim Erstellen der Konfiguration'
          }
        />,
      );
    }
  };

  return (
    <MultiStepForm steps={steps} onSubmit={handleSubmit} onCancel={onCancel} />
  );
}
